import { Component, OnInit } from '@angular/core';
import { SliderOpacityService } from 'lib';

@Component({
  selector: 'web-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
})
export class SliderComponent implements OnInit {
  value$ = this.service.changed;
  constructor(private service: SliderOpacityService) {}

  ngOnInit() {}

  valueChange(e) {
    this.service.opacity = e;
  }
}
